function removeTransferenceObservationSignatureFromBody(body) {
  return body.split("\n\n")[1];
}

export default removeTransferenceObservationSignatureFromBody;